import { SnackbarButton } from '../../components/Buttons/SnackbarButton';
import { CheckCircle, Cancel } from '@mui/icons-material';

export const toastConfig = {
  icon: (
    <span
      style={{
        height: 24,
        width: 24,
        backgroundColor: '#ffffff',
        borderRadius: '50%',
        display: 'inline-block',
      }}
    >
      <CheckCircle
        sx={{
          color: '#318765',
          filter:
            'invert(43%) sepia(17%) saturate(1388%) hue-rotate(104deg) brightness(99%) contrast(85%)',
        }}
      />
    </span>
  ),
  closeButton: <SnackbarButton message="Got it" />,
};

export const toastErrorConfig = {
  icon: (
    <span
      style={{
        height: 24,
        width: 24,
        backgroundColor: '#ffffff',
        borderRadius: '50%',
        display: 'inline-block',
      }}
    >
      <Cancel
        sx={{
          color: '#C00029',
          filter:
            'invert(9%) sepia(86%) saturate(5279%) hue-rotate(333deg) brightness(101%) contrast(131%)',
        }}
      />
    </span>
  ),
  closeButton: <SnackbarButton message="Dismiss" />,
};
